import React from "react";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "./react-draft-wysiwyg.css";
import "./RichTextEditorComponent.css";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import axios from "../../api/utils/axiosInstance";
import CustomOption from "./CustomOptions/CustomOption";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import Modal from "../UI/Modal/Modal";
import InputComponent from "../UI/InputComponent/InputComponent";
import Dropdown from "../UI/Dropdown/Dropdown";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { withRouter } from "react-router-dom";
import Row from "../EntryForms/WrapperComponents/Row";
import Col from "../EntryForms/WrapperComponents/Col";
import axiosInstance from "../../api/utils/axiosInstance";
import moment from "moment";
import { SignatureModal } from "../../containers/Signature/SignatureModal";

class RichTextEditorComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      templateForDelete: "",
      error: false,
      editorState: EditorState.createEmpty(),
      placeholderOptions: [],
      saveTemplateModalVisible: false,
      confirmationDialogVisible: false,
      selectedRjesenjeId: null,
      nazivPredloska: "",
      predlozakStatusId: "",
      showDeleteTemplateModal: false,
      showConfirmDialog: false,
      placeholderDropdownOpened: false,
      selectedOption: { nazivRjesenja: "Odaberite predložak"},
      status: "",
      isLoading: false,
      showSignatureConfirmation: false,
      zahtjevAtrId:"",
    };
  }

  componentDidMount() {
    this.getAllPredlosci();
  }

  getAllPredlosci = async () => {
    const { data } = await axiosInstance.get("/predlosci/");
    this.setState({
      placeholderOptions: [
        {
          idRjesenja: null,
          nazivRjesenja: "Novi predložak",
          predlozak: "",
        },
        ...data,
      ],
    });
  };

  setNewTemplate(html) {
    const contentBlock = htmlToDraft(html);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      this.setState({
        editorState,
      });
    }
  }

  createElementFromHTML(htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  activateArial = () => {
    //ovo je potrebno kako bi se ispravno prikazivlai dijakriticki znakovi kada se kreira novi predlozak
    //prijasnja implementacija ukljucivala je samo prvu liniju ove funkcije
    let rjesenje = draftToHtml(convertToRaw(this.state.editorState.getCurrentContent()));

    let tempRjesenje = (rjesenje.split(/<p>(.*?)<\/p>/)).map((element)=>{
      if(element.includes('<span style=\"font-family: Arial;\"')){
        return `<p>${element}<\/p>`
      }else if(element === '\n' || element === ''){
        return ''
      }else{
        return `<p><span style=\"font-family: Arial;\">${element}<\/span><\/p>`
      }
    });
    rjesenje =''.concat(...tempRjesenje);
    return rjesenje;
  }

  pregledajPrijeSpremanja = () => {
    let rjesenje = this.activateArial();

    axios.post(`/print/html-to-pdf`, { htmlContent: rjesenje }).then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([this.b64toBlob(res.data)])
      );
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", "rjesenje.pdf");
      document.body.appendChild(link);
      link.click();
    });
  };

  b64toBlob = (b64Data, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  b64DecodeUnicode(str) {
    // Going backwards: from bytestream, to percent-encoding, to original string.
    return decodeURIComponent(
      atob(str)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
  }

  setSelectedOption = (selectedOption) => {
    this.setState({
      selectedOption: selectedOption,
      selectedRjesenjeId: selectedOption.idRjesenja,
      templateForDelete: selectedOption.idRjesenja,
    });

    if (selectedOption.idRjesenja) {
      let zahtjev;

      axiosInstance
        .get("/request/" + this.props.zahtjevAtrId + "?isEdit=true")
        .then((res) => {
          zahtjev = res.data;

          axios.get("/predlosci/" + selectedOption.idRjesenja).then((res) => {
            let replacedTemplate = res.data.predlozak.replace(
              "{{datum}}",
              moment(new Date()).format("LL")
            );

            replacedTemplate = replacedTemplate.replace(
              "{{klasa}}",
              zahtjev ? zahtjev.klasa : ""
            );
            replacedTemplate = replacedTemplate.replace(
              "{{urBroj}}",
              zahtjev ? zahtjev.urBroj : ""
            );
            this.setNewTemplate(res.data.predlozak ? replacedTemplate : "");
          });
        });
    } else {
      this.setNewTemplate("");
    }
  };

  showSaveTemplateModal = (idRjesenja) => (e) => {
    e.preventDefault();
    if (!idRjesenja) this.setState({ saveTemplateModalVisible: true });
    else this.showConfirmationDialogModal();
  };

  showConfirmationDialogModal = () => {
    const { nazivPredloska, predlozakStatusId, selectedRjesenjeId } =
      this.state;

    if (
      (nazivPredloska.length < 1 || !predlozakStatusId) &&
      !selectedRjesenjeId
    ) {
      this.setState({ error: true });
      return;
    }

    this.setState({ confirmationDialogVisible: true, error: false });
  };

  hideConfirmationDialogModal = () => {
    this.setState({ confirmationDialogVisible: false });
  };

  saveTemplate = () => {
    const { nazivPredloska, selectedRjesenjeId, predlozakStatusId } =
      this.state;
    let newTemplate = {
      nazivRjesenja: nazivPredloska,
      idRjesenja: selectedRjesenjeId,
      status: predlozakStatusId,
      predlozak: this.activateArial(),
    };

    if (selectedRjesenjeId) {
      this.updateTemplate(newTemplate);
    } else {
      this.createNewTemplate(newTemplate);
    }
  };

  createNewTemplate = async (template) => {
    try {
      const res = await axiosInstance.post("/predlosci/", template);

      this.setState(
        {
          confirmationDialogVisible: false,
          saveTemplateModalVisible: false,
          editorState: EditorState.createEmpty(),
          nazivPredloska: "",
          predlozakStatusId: "",
        },
        () => {
          toast.success("Predložak je uspješno kreiran!", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          this.getAllPredlosci();
        }
      );
    } catch (e) {
      toast.info("Nešto je pošlo po krivu!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  updateTemplate = async (template) => {
    try {
      const res = axiosInstance.patch("/predlosci/", template);

      this.setState(
        {
          confirmationDialogVisible: false,
          saveTemplateModalVisible: false,
        },
        () => {
          toast.success("Predložak je uspješno ažuriran.", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          this.getAllPredlosci();
        }
      );
    } catch (e) {
      toast.info("Nešto je pošlo po krivu!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  hideSaveTemplateModal = () => {
    this.setState({
      saveTemplateModalVisible: false,
      error: false,
      predlozakStatusId: "",
      nazivPredloska: "",
    });
  };

  setNazivPredloska = (e) => {
    this.setState({ nazivPredloska: e.target.value });
  };

  showDeleteTemplateModal = () => {
    this.setState({
      showDeleteTemplateModal: true,
    });
  };

  hideDeleteTemplateModal = () => {
    this.setState({
      showDeleteTemplateModal: false,
      templateForDelete: "",
    });
  };

  openConfirmDialog = () => {
    this.setState({ showConfirmDialog: true });
  };

  hideConfirmDialog = () => {
    this.setState({ showConfirmDialog: false });
  };

  selectTemplateForDelete = (e) => {
    const value = e.target.value;
    this.setState({ templateForDelete: value });
  };

  deleteTemplate = async () => {
    const idRjesenja = this.state.templateForDelete;

    try {
      const res = await axiosInstance.delete(`/predlosci/${idRjesenja}
      `);

      toast.success("Predložak je uspješno obrisan!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });

      this.setState(
        {
          showConfirmDialog: false,
          showDeleteTemplateModal: false,
          templateForDelete: "",
          editorState: EditorState.createEmpty(),

          selectedOption: {
            idRjesenja: null,
            nazivRjesenja: "Novi predložak",
            predlozak: "",
          },
        },
        () => {
          this.getAllPredlosci();
        }
      );
    } catch (e) {
      toast.info("Nešto je pošlo po krivu!", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  onDropdownChanged = (e) => {
    this.setState({ predlozakStatusId: e.target.value });
  };

  openPlaceholderDropdown = () => {
    this.setState({
      placeholderDropdownOpened: !this.state.placeholderDropdownOpened,
    });
  };

  saveRjesenje = async () => {
      this.setState({isLoading:true});
      let rjesenje = this.activateArial();
      const { selectedRjesenjeId } = this.state;

      let rjesenjeContent = {
        zahtjevAtrId: this.props.zahtjevAtrId,
        idRjesenja: selectedRjesenjeId,
        htmlContent: rjesenje,
      };

      try {
        const res = await axiosInstance.patch(
          "/requests/set-status-editor",
          rjesenjeContent
        );

        this.setState({zahtjevAtrId: res.data.zahtjevAtrId});
        toast.success("Dokument je uspješno spremljen", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } catch (e) {
        toast.info("Nešto je pošlo po krivu! Molimo pokušajte ponovo", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } finally {
        this.setState({ isLoading: false });
      }
  };

  redirectToOdobrenjeZahtjeva = () => {
    this.props.history.push("/odobrenje-zahtjeva");
  };

  openSignatureConfirmationModal = () => {
    this.setState({
      showSignatureConfirmation:true,
    })
  }

  saveSolutionAndAskForSignature = async () => {
    //inserts now row into zahtjevi_atr and zahtjevi_dokumenti, 
    // representing solution document and new state based uopon template file choosen 
    await this.saveRjesenje();
    if(this.props.userRole === "ROLE_SLUZBENIK"){
      this.openSignatureConfirmationModal();
    }
  }

  closeSignatureConfirmationModal = () => {
    this.setState({
      showSignatureConfirmation:false,
      zahtjevAtrId:"",
    });
    this.redirectToOdobrenjeZahtjeva();
  }

  render() {
    const { selectedRjesenjeId } = this.state;

    const mappedDeleteDropdownData = this.state.placeholderOptions
      .filter((element) => element.idRjesenja != null)
      .map((element) => {
        return (
          <option key={element.idRjesenja} value={element.idRjesenja}>
            {element.nazivRjesenja}
          </option>
        );
      });

    const { editorState } = this.state;

    const dropdownData = [
      {
        id: 1,
        value: "ZAPRIMLJENO",
      },
      { id: 2, value: "PREUZETO" },
      { id: 3, value: "DOPUNA" },
      { id: 4, value: "ODBACENO" },
      { id: 5, value: "OBUSTAVLJENO" },
      { id: 6, value: "ODBIJENO" },
      { id: 7, value: "U OBRADI" },
      { id: 8, value: "PRIHVACENO" },
      { id: 9, value: "UPISANO" },
      { id: 10, value: "BRISAN" },
    ];

    const mappedDropdownData = dropdownData.map((element) => {
      return (
        <option key={element.id} value={element.id}>
          {element.value}
        </option>
      );
    });

    // confirmationDialog modal

    let confirmationMessage = selectedRjesenjeId ? (
      <p>Predložak već postoji. Želite li ga prebrisati? </p>
    ) : (
      <p>Jeste li sigurni da želite spremiti novi predložak?</p>
    );

    let confirmationModal = (
      <Modal
        show={this.state.confirmationDialogVisible}
        onHide={this.hideConfirmationDialogModal}
        title={"Spremanje predloška"}
        style={{ zIndex: "9999999" }}
        size={"md"}
        className={` ${
          this.props.visionImpaired ? " visionImpaired" : ""
        }  font${this.props.fontSize}`}
      >
        <div>
          {confirmationMessage}

          <div style={{ float: "right" }}>
            <ButtonComponent
              style={{ marginRight: "10px" }}
              onClick={this.saveTemplate}
            >
              Da
            </ButtonComponent>

            <ButtonComponent
              variant="danger"
              // style={{ float: "right" }}
              onClick={this.hideConfirmationDialogModal}
            >
              Ne
            </ButtonComponent>
          </div>
        </div>
      </Modal>
    );

    return (
      <div style={{ marginLeft: "32px", marginRight: "32px" }}>
        <Editor
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editor-class"
          onEditorStateChange={this.onEditorStateChange}
          toolbar={{
            options: [
              "inline",
              "blockType",
              "fontSize",
              "fontFamily",
              "list",
              "textAlign",
            ],
            fontFamily: { options: ["Arial"]},
          }}
          toolbarCustomButtons={[
            <CustomOption
              placeholderOptions={this.state.placeholderOptions}
              saveTemplate={this.showSaveTemplateModal}
              showDeleteTemplateModal={this.showDeleteTemplateModal}
              defaultValue={selectedRjesenjeId}
              openPlaceholderDropdown={this.openPlaceholderDropdown}
              placeholderDropdownOpened={this.state.placeholderDropdownOpened}
              setSelectedOption={this.setSelectedOption}
              selectedOption={this.state.selectedOption}
            />,
          ]}
        />
        {/* <textarea
          disabled
          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
          style={{height: '500px', width: '100%'}}
        /> */}
        <Modal
          show={this.state.saveTemplateModalVisible}
          onHide={this.hideSaveTemplateModal}
          title={"Spremanje predloška"}
          style={{ zIndex: "999998" }}
          className={` ${
            this.props.visionImpaired ? " visionImpaired" : ""
          }  font${this.props.fontSize}`}
        >
          <div>
            {!selectedRjesenjeId ? (
              <>
                <InputComponent
                  style={
                    this.state.error &&
                    this.state.nazivPredloska.length < 1 &&
                    "red"
                  }
                  value={this.state.nazivPredloska}
                  placeholder={"Naziv predloška"}
                  onChange={this.setNazivPredloska}
                />
                {this.state.nazivPredloska.length < 1 && this.state.error && (
                  <p style={{ color: "red" }}>Unesite naziv predloška!</p>
                )}
              </>
            ) : null}
            {!selectedRjesenjeId ? (
              <>
                <Dropdown
                  style={
                    this.state.error && !this.state.predlozakStatusId && "red"
                  }
                  hidden
                  onChange={this.onDropdownChanged}
                  value={this.state.predlozakStatusId}
                  asProperty="select"
                  map={mappedDropdownData}
                  text="Status"
                />{" "}
                {!this.state.predlozakStatusId && this.state.error && (
                  <p style={{ color: "red" }}>Odaberite status!</p>
                )}
              </>
            ) : null}
            <ButtonComponent
              style={{ float: "right" }}
              onClick={this.showConfirmationDialogModal}
            >
              Spremi predložak
            </ButtonComponent>
          </div>
        </Modal>
        <Modal
          show={this.state.showDeleteTemplateModal}
          onHide={this.hideDeleteTemplateModal}
          title={"Brisanje predložaka"}
          style={{ zIndex: "999998" }}
          className={` ${
            this.props.visionImpaired ? " visionImpaired" : ""
          }  font${this.props.fontSize}`}
        >
          <Dropdown
            onChange={this.selectTemplateForDelete}
            value={this.state.templateForDelete}
            asProperty="select"
            map={mappedDeleteDropdownData}
            hidden
            text={"Odaberite predložak"}
          ></Dropdown>
          <Row>
            <ButtonComponent
              onClick={this.openConfirmDialog}
              disabled={
                this.state.templateForDelete == "" ||
                this.state.templateForDelete == null
                  ? true
                  : false
              }
            >
              Obriši
            </ButtonComponent>
          </Row>
          <Modal
            show={this.state.showConfirmDialog}
            onHide={this.hideConfirmDialog}
            title={"Brisanje predloška"}
            className={` ${
              this.props.visionImpaired ? " visionImpaired" : ""
            }  font${this.props.fontSize}`}
          >
            <p>Jeste li sigurni da želite obrisati predložak?</p>
            <Row>
              <Col>
                <ButtonComponent
                  block
                  variant="danger"
                  onClick={this.deleteTemplate}
                >
                  Da
                </ButtonComponent>
              </Col>
              <Col>
                <ButtonComponent
                  block
                  onClick={this.hideConfirmDialog}
                  style={{ marginLeft: "5px" }}
                >
                  Ne
                </ButtonComponent>
              </Col>
            </Row>
          </Modal>
        </Modal>
        <div
          style={{ float: "right", marginTop: "16px", marginBottom: "16px" }}
          className="invert"
        >
          <ButtonComponent
            onClick={this.pregledajPrijeSpremanja}
            disabled={!editorState.getCurrentContent().hasText()}
          >
            Pregledaj prije spremanja
          </ButtonComponent>
          <ButtonComponent
            style={{ marginLeft: "4px" }}
            loading={this.state.isLoading}
            onClick={this.saveSolutionAndAskForSignature}
            disabled={
              !editorState.getCurrentContent().hasText() ||
              this.state.selectedRjesenjeId == null
            }
          >
            Izdaj dokument
          </ButtonComponent>
        </div>

        {
          //potvad potpiivanja i modal za potpisivanje
        }
        <SignatureModal show={this.state.showSignatureConfirmation} zahtjevAtrId={this.state.zahtjevAtrId} dataType={"rjesenje"}
          onHide={this.closeSignatureConfirmationModal}
          onCancel={this.closeSignatureConfirmationModal}
          onFinished={this.redirectToOdobrenjeZahtjeva} />

        {confirmationModal}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zahtjevAtrId: state.formData.zahtjevAtrId,
    userRole: state.authentication.userData
      ? state.authentication.userData.roles[0].roleName
      : "",
    visionImpaired: state.layout.visionImpaired,
    fontSize: state.layout.fontSize,
  };
};

export default connect(mapStateToProps)(withRouter(RichTextEditorComponent));
